import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl, FormBuilder, NgForm, Validators,FormArray } from '@angular/forms';
import {Router} from '@angular/router';
import {PredictionserviceService} from '../predictionservice.service';

@Component({
  selector: 'app-prediction',
  templateUrl: './prediction.component.html',
  styleUrls: ['./prediction.component.css'],
  providers:[PredictionserviceService]
})
export class PredictionComponent implements OnInit {
  feedbackForm:any=FormGroup;
  constructor(private serv:PredictionserviceService,private router:Router,private fb:FormBuilder) { }
  user=JSON.parse(localStorage.getItem('loginUser'));
  prediction=JSON.parse(localStorage.getItem('pre'));
  gen:string[]=["Moderate","Good","Very good","Excellent","Bad"];
  ngOnInit(): void {

    if(this.prediction=='1'){
      this.prediction="Suffered";
    }
    else{
      this.prediction="Not Suffered";
    }
    this.feedbackForm=this.fb.group({
      comment:[null],
      satisfaction:[null,[Validators.required]]
    });
  }
  back(){
    this.router.navigate(['/user/form']);
  }
  public show:boolean = false;
  public buttonName:any = 'Help Us for more better application';
  toggle() {
    this.show = !this.show;
    // CHANGE THE NAME OF THE BUTTON.
    if(this.show)
      this.buttonName = "Close";
    else
      this.buttonName = "Help Us for more better application";
  }
  feedback:any
  submit(){
      this.feedback={
        email:this.user.email,
        name:this.user.name,
        comment:this.feedbackForm.controls.comment.value,
        satisfaction:this.feedbackForm.controls.satisfaction.value
      };
      alert("Thank You Soo much for your valuable Feedback!!")
      this.show=false;
      this.buttonName = "Help Us for more better application";
      console.log(this.feedback);

          this.serv.feed(this.feedback).subscribe(
            data=>{
              console.log("data is posted");
            },
            error=>{
              console.log("ERROR");
            }
          );

  }

}
